import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RequestPermissionNotificationType } from '../../../../models/enums/request-permission-notification-type';
import { MakeRequestPermissionCriteria } from '../../../../models/search-criterias/make-request-permission-criteria';
import { ResponseState } from '../../../../models/support/response-state';
import { AppointmentService } from '../../../../services/appointment/appointment.service';
import { SharedService } from '../../../../services/other/shared.service';
import { RequestPermissionNotificationModel } from 'src/app/models/classes/notification/request-permission-notification-model';
declare var $: any;

@Component({
  selector: 'app-check-request-permission',
  templateUrl: './check-request-permission.component.html',
  styleUrls: ['./check-request-permission.component.scss']
})
export class CheckRequestPermissionComponent implements OnInit {


  @Input() message;
  @Input() RequestPermissionNotificationModel: RequestPermissionNotificationModel;
  @Output() getPermissionNotificationId = new EventEmitter<string>();
  btnLoading: boolean = false;
  public RequestPermissionName: string;
  public SendFeedbackToAdmin: string = null;

  constructor(
    public activeModal: NgbActiveModal,
    public sharedService: SharedService,
    public appointmentService: AppointmentService,
    public ngbModal: NgbModal,

  ) { }

  ngOnInit(): void {
    if (this.message) {
      console.log(this.message)
    }


    this.RequestPermissionName =
      this.RequestPermissionNotificationModel.RequestPermissionNotificationType ==
        RequestPermissionNotificationType.DiscountPermission ?
        "RequestDiscountPermission" :
        this.RequestPermissionNotificationModel.RequestPermissionNotificationType ==
          RequestPermissionNotificationType.SaleRefundPermission ?
          "RequestSaleRefundPermission" :
          this.RequestPermissionNotificationModel.RequestPermissionNotificationType ==
            RequestPermissionNotificationType.EditBillPermission ?
            "RequestEditBillPermission" :
            this.RequestPermissionNotificationModel.RequestPermissionNotificationType ==
              RequestPermissionNotificationType.CancelBookingPermission ?
              "CancelBookingPermission" : "";


  }

  public get requestPermissionNotificationType(): typeof RequestPermissionNotificationType {
    return RequestPermissionNotificationType;
  }

  MakeRequestPermission() {
    this.btnLoading = true;
    var makeRequestPermissionCriteria = new MakeRequestPermissionCriteria();
    makeRequestPermissionCriteria.BookingId = this.RequestPermissionNotificationModel.BookingId
    makeRequestPermissionCriteria.BranchId = this.sharedService.AccountSetupId;
    makeRequestPermissionCriteria.ClientId = this.RequestPermissionNotificationModel.BookingOrTransactionClientId;

    makeRequestPermissionCriteria.TotalAmountBeforeDiscount = this.RequestPermissionNotificationModel.BookingOrTransactionTotalAmountBeforeDiscount;
    makeRequestPermissionCriteria.TotalDiscountAmount = this.RequestPermissionNotificationModel.BookingOrTransactionDiscountValueAll;
    makeRequestPermissionCriteria.TotalAmountAfterDiscount = this.RequestPermissionNotificationModel.BookingOrTransactionTotalAmountAfterDiscount;
    makeRequestPermissionCriteria.TotalAmount = this.RequestPermissionNotificationModel.BookingOrTransactionTotalPrice;


    makeRequestPermissionCriteria.BookingId = this.RequestPermissionNotificationModel.BookingId;
    makeRequestPermissionCriteria.BookingDateTime = this.RequestPermissionNotificationModel.BookingDateTime;
    makeRequestPermissionCriteria.BookingStatus = this.RequestPermissionNotificationModel.BookingStatus;
    makeRequestPermissionCriteria.BookingPaidStatus = this.RequestPermissionNotificationModel.BookingPaidStatus;

    makeRequestPermissionCriteria.RequestPermissionNotificationType = this.RequestPermissionNotificationModel.RequestPermissionNotificationType;

    makeRequestPermissionCriteria.RefundReasonId =
      this.RequestPermissionNotificationModel.RefundReasonId;

    makeRequestPermissionCriteria.RefundedItemsCount =
      this.RequestPermissionNotificationModel.RefundedItemsCount;

    makeRequestPermissionCriteria.EditedTransaction =
      this.RequestPermissionNotificationModel.EditedTransaction;

    makeRequestPermissionCriteria.RequestPermissionNotificationItems =
      this.RequestPermissionNotificationModel.RequestPermissionNotificationItems;

    makeRequestPermissionCriteria.RequestPermissionNotificationPayments =
      this.RequestPermissionNotificationModel.RequestPermissionNotificationPayments;


    makeRequestPermissionCriteria.Notes = this.SendFeedbackToAdmin;

    this.appointmentService.MakeRequestPermission(makeRequestPermissionCriteria).subscribe((response: any) => {

      if (response.State == ResponseState.Success) {
        this.sharedService.ToastrSuccess(response.Message)
        this.getPermissionNotificationId.emit(response.RequestPermissionNotificationId);
        //this.ngbModal.dismissAll();
        //$('#ModalViewDailySales').modal('hide');
        this.btnLoading = false;
      }
      else {
        this.sharedService.ToastrError(response.Message)
        this.btnLoading = false;
      }
    });
  }
}

